import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Button, CircularProgress, Box, Grid, Typography,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import { Img } from 'react-image';
import { uniqueId, isEmpty } from 'lodash';
import moment from 'moment';
import 'moment/locale/th';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { styles } from '../style';
import '../styles.css';

const useStyles = makeStyles(styles);

export default function WaterLavelDatalists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [hasError, sethasError] = useState();

  const hostApi = `${process.env.REACT_APP_API_URL}`;
  const [photoIndex, setphotoIndex] = useState();
  const arrayImage = [];
  const [isOpen, setIsOpen] = useState(false);
  const [Sea, setSea] = useState([{}, {}, {}, {}, {}, {}, {}]);
  const placeHolder = 'https://via.placeholder.com/322x230?text=No%20Image&italic=true';

  useEffect(() => {
    function getData() {
      setLoading(true);
      fetch(`${hostApi}/public/wave_forecast_img`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          setSea([...data.data]);
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    getData();
  }, [hostApi]);

  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}

      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item>
            <Typography className={classes.titleSub}>
              {t('แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองคลื่นทะเล (SWAN Model)')}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          {Sea.slice(0, 3).map((img, i) => {
            let toshow = '';
            if (img.media_path === undefined || img.media_path === '') {
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleBox}>{t('ไม่มีข้อมูล')}</Box>
                  <Box className={classes.bodyBox}><Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} /></Box>
                </Box>
              );
            } else {
              arrayImage.push({
                src: `${hostApi}/shared/image?_csrf=&image=${img.media_path}`,
                title: `${img.media_datetime}`,
              });
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleBox}>{moment(img.media_datetime).format('ll')}</Box>
                  <Box className={classes.bodyBox}>
                    <Button id={`forecast_wave_${i}`} onClick={() => { setIsOpen(true); setphotoIndex(i); }}>
                      <Img
                        src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`}
                        alt={img.media_datetime}
                        className={classes.img}
                        unloader={(
                          <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                        )}
                      />
                    </Button>
                  </Box>
                </Box>
              );
            }
            return (
              <Grid item sm={4} md={4} key={uniqueId()}>
                {toshow}
              </Grid>
            );
          })}
        </Grid>

        <Grid container spacing={3} justifyContent="space-around">
          {Sea.slice(3, 7).map((img, i) => {
            let toshow = '';
            if (img.media_path === undefined || img.media_path === '') {
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleSecondBox}>{t('ไม่มีข้อมูล')}</Box>
                  <Box className={classes.bodyBox}><Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} /></Box>
                </Box>
              );
            } else {
              arrayImage.push({
                src: `${hostApi}/shared/image?_csrf=&image=${img.media_path}`,
                title: `${img.media_datetime}`,
              });
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleSecondBox}>{moment(img.media_datetime).format('ll')}</Box>
                  <Box className={classes.bodyBox}>
                    <Button id={`forecast_wave_${i + 3}`} onClick={() => { setIsOpen(true); setphotoIndex(i + 3); }}>
                      <Img
                        src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`}
                        alt={img.media_datetime}
                        className={classes.img}
                        unloader={(
                          <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                        )}
                      />
                    </Button>
                  </Box>
                </Box>
              );
            }
            return (
              <Grid item xs={6} sm={3} md={3} key={uniqueId()}>
                {toshow}
              </Grid>
            );
          })}
        </Grid>

      </div>
      {isEmpty(arrayImage[photoIndex]) === false && isOpen && (
        <Lightbox
          mainSrc={arrayImage[photoIndex].src}
          nextSrc={arrayImage[(photoIndex + 1) % arrayImage.length].src}
          prevSrc={arrayImage[(photoIndex + arrayImage.length - 1) % arrayImage.length].src}
          imageTitle={arrayImage[photoIndex].title}
          onCloseRequest={() => { setIsOpen(false); setphotoIndex(1); }}
          onMovePrevRequest={() => {
            setphotoIndex((photoIndex + arrayImage.length - 1) % arrayImage.length);
          }}
          onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % arrayImage.length)}
          reactModalStyle={{
            overlay: { zIndex: '10000000' },
          }}
        />
      )}

    </>
  );
}
